export default __webpack_public_path__ + "static/media/layer-offline.045e4756.svg";